import React from 'react';
import {BankIDViewCreated, BankIDViewCreatedProps} from './BankIDViewCreated';
import {BankIDViewLoading} from './BankIDViewLoading';
import {Box} from '@mui/material';
import {BankIDStatus} from '../../hooks/useBankIDStatus';
import {BankIDSignStatus} from '../../hooks/useBankIDSignStatus';

export type BankIDViewProps = BankIDViewCreatedProps & {
  status: BankIDStatus | BankIDSignStatus | undefined;
};

export const BankIDView: React.FC<BankIDViewProps> = (props) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
      <Box
        sx={(theme) => ({
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          px: 3,
          py: 2,
          maxWidth: 400,
          borderRadius: 1,
          width: {md: 400},
          minHeight: {md: 560},
          backgroundColor: {md: theme.palette.background.paper},
        })}>
        <BankIDViewContent {...props} />
      </Box>
    </Box>
  );
};

const BankIDViewContent: React.FC<BankIDViewProps> = ({
  status,
  type,
  token,
  onCancel,
  autoStartToken,
  expiresAt,
  qrCode,
  authToken,
  bft,
  host,
  useReturnUrl,
  refreshAuthToken,
}) => {
  // windows firefox produce recursive navigation error
  // Too many calls to location or history APIs in a short period of time
  // https://github.com/livewire/livewire/discussions/7746
  // if (isWindows && isFirefox) {
  //   return <BankIDViewFirefoxError />;
  // }
  // Tested by eID, seems to work now 2025-10-07

  // BankID authentication session not started
  if (status === undefined) {
    return <BankIDViewLoading />;
  }

  // if (status === 'EXPIRED' || status === 'UNKNOWN') {
  //   return <BankIDViewExpired />;
  // }

  // if (status === 'FAILED') {
  //   return <BankIDViewError />;
  // }

  return (
    <BankIDViewCreated
      type={type}
      token={token}
      onCancel={onCancel}
      autoStartToken={autoStartToken}
      expiresAt={expiresAt}
      qrCode={qrCode}
      authToken={authToken}
      bft={bft}
      host={host}
      useReturnUrl={useReturnUrl}
      refreshAuthToken={refreshAuthToken}
    />
  );
};
